import axios from "axios";

export const useProductRequests = () => {
  const getSearchCompleteRequest = async (string) => {
    return axios({
      method: "GET",
      url: `${
        process.env.REACT_APP_API +
        process.env.REACT_APP_GET_SEARCH_COMPLETE +
        `?title=${string}`
      }`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_GET_SEARCH_COMPLETE
        }/?count=10`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };
  const getSearchComplete = async (string) => {
    const cachedSearchComplete = localStorage.getItem(
      "conteynersearch" + string.replace(/\s+/g, "-space-")
    );
    var currentDate = new Date();
    var secondsSinceEpoch = currentDate.getTime() / 1000;
    if (cachedSearchComplete != null) {
      const check = await JSON.parse(cachedSearchComplete);
      if (check.timestamp > secondsSinceEpoch) {
        console.log(check);
        return check.data;
      }
    }
    const result = await getSearchCompleteRequest(string);
    localStorage.setItem(
      "conteynersearch" + string.replace(/\s+/g, "-space-"),
      JSON.stringify({
        timestamp: secondsSinceEpoch + 60 * 60,
        data: result,
      })
    );
    return result;
  };

  const getProducts = async (data = {}) => {
    /*
      page=${data.page||"1"}&
      name=${data.name||""}&
      description=${data.description||""}&
      price=${data.price||""}&
      stock=${data.stock||""}&
      slug=${data.slug||""}&
      categorySlug=${data.category||""}&
      sort=${data.sort||""}&
      allSearch=${data.allSearch||""}
    */
    return axios({
      method: "POST",
      url: `${process.env.REACT_APP_API + process.env.REACT_APP_PRODUCTS}`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_PRODUCTS
        }/?count=10`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };
  const getSliders = async (count = null) => {
    return axios({
      method: "GET",
      url: `${process.env.REACT_APP_API + process.env.REACT_APP_GET_SLIDERS}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const getProduct = async (id) => {
    return axios({
      method: "GET",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_PRODUCT
      }?slug=${id}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_PRODUCTS
        }/${id}`,
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };

  const getDiscover = async (data = {}) => {
    return axios({
      method: "POST",
      url: `${process.env.REACT_APP_API + process.env.REACT_APP_PRODUCTS}`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };
  const getCategoryRequest = async (brand) => {
    return axios({
      method: "GET",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_CATEGORIES
      }?brandSlug=${brand}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };
  const getCategories = async (brand = "") => {
    const cachedCategoryies = localStorage.getItem("conteynercategories" + brand);
    var currentDate = new Date();
    var secondsSinceEpoch = currentDate.getTime() / 1000;
    if (cachedCategoryies != null) {
      const check = await JSON.parse(cachedCategoryies);
      if (check.timestamp > secondsSinceEpoch) {
        console.log(check);
        return check.data;
      }
    }
    const categories = await getCategoryRequest(brand);
    localStorage.setItem(
      "conteynercategories" + brand,
      JSON.stringify({
        timestamp: secondsSinceEpoch + 60 * 60,
        data: categories,
      })
    );
    console.log("cat", categories);
    return categories;
  };
  const getBrandsRequest = async (brand, mode) => {
    return axios({
      method: "GET",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_BRANDS
      }?groupSlug=${brand}&productImage=${mode == "2" ? true : false}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `${localStorage.getItem("conteynertoken")}`,
      },
    });
  };
  const getBrands = async (brand = "", mode = "1") => {
    const cachedCategoryies = localStorage.getItem(
      "conteynerbrands" + brand + mode
    );
    var currentDate = new Date();
    var secondsSinceEpoch = currentDate.getTime() / 1000;
    if (cachedCategoryies != null) {
      const check = await JSON.parse(cachedCategoryies);
      if (check.timestamp > secondsSinceEpoch) {
        console.log(check);
        return check.data;
      }
    }
    const brands = await getBrandsRequest(brand, mode);
    localStorage.setItem(
      "conteynerbrands" + brand + mode,
      JSON.stringify({
        timestamp: secondsSinceEpoch + 60 * 60,
        data: brands,
      })
    );
    return brands;
  };

  return {
    getSearchComplete,
    getProducts,
    getProduct,
    getDiscover,
    getCategories,
    getBrands,
    getSliders,
  };
};
